module.exports = __webpack_public_path__ + "media/images/default/lp_about_pc-5691891b3755b2f4d9750d163632b226.svg";